module.exports = __webpack_public_path__ + "static/img/06.bca3c5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/06.png
// module id = 19LH
// module chunks = 0